<div class="turnover-list-widget display-flex justify-content-space-between" [class.collapsed]="collapsed">
  <ng-container [ngTemplateOutlet]="isLoading ? spinner : widget"></ng-container>
</div>

<ng-template #widget>
  <div class="content display-flex flex-column justify-content-space-between">
    <h4 class="m-0">{{ header }}</h4>
    <div class="collapsed-value-container">
      <ng-container
        [ngTemplateOutlet]="_widgetItem.value !== null ? value : emptyValue"
        [ngTemplateOutletContext]="{ shortFormat: true }"
      ></ng-container>
    </div>
    <div class="label-container display-flex grid-gap-4 align-items-end">
      <ng-container
        [ngTemplateOutlet]="_widgetItem.value !== null ? value : emptyValue"
        [ngTemplateOutletContext]="{ shortFormat: false }"
      ></ng-container>
    </div>
  </div>
  <div *ngIf="withChart" class="turnover-list-widget-chart" [ngClass]="[isLoading ? 'display-none' : '']">
    <app-chart
      class="pie-chart"
      [chartDataList]="chartDataList"
      [chartType]="ChartTypes.DOUGHNUT"
      [chartConfig]="chartConfig"
      [displayLegend]="false"
      [emptyChartLabel]="NoValue"
    ></app-chart>
  </div>
  <div *ngIf="_oppositeValue !== null" class="turnover-list-widget-opposite fs s10">
    <div class="text-color gray">{{ oppositeLabel }}</div>
    <div class="text-color gray7">{{ _oppositeValue }}%</div>
  </div>
</ng-template>

<ng-template #spinner>
  <div class="display-flex justify-content-center align-items-center w-100">
    <mat-spinner [diameter]="collapsed ? 20 : 80"></mat-spinner>
  </div>
</ng-template>

<ng-template #emptyValue>
  <span class="value">-</span>
</ng-template>

<ng-template #value let-shortFormat="shortFormat">
  <span
    class="text-color"
    [ngClass]="{
      red2: _widgetItem.value < 0
    }"
  >
    <span [ngClass]="_widgetItem.value | thresholdConfiguration: _widgetItem.thresholdsConfiguration">
      <span *ngIf="measureType === '$'" class="units currency">{{
        measureType | measureType: _widgetItem.value:shortFormat
      }}</span>
      <span class="value">{{ abbreviateNumber(_widgetItem.value, 0) }}</span>
      <span *ngIf="measureType !== '$'" class="units">{{
        measureType | measureType: _widgetItem.value:shortFormat
      }}</span>
    </span>
  </span>
</ng-template>
